export const featureComponentsDes = {
  competencyAndArchetypeTipModal: {
    title: 'Archetypes and Skills',
    tipModalInfo: [
      {
        h: 'What are Archetypes and Skills?',
        p: `<ul>
              <li>
                  <b>Archetypes</b> focus on the craft of what someone does. They define the specific combinations of Skills and the depth of expertise that are typically needed to deliver value, reflecting the common patterns found across our projects.
              </li>
              <li>
                  <b>Skills</b> are the fundamental unit of the model. They encompass the combination of knowledge, behavior, and applied abilities that enable Thoughtworkers to deliver capabilities and value. They provide evidence of what you have experience in, and what you want to grow in the future.
                  <br><br>
                  We organize all Skills into four distinct categories:
                  <ul>
                    <li><b>Core Skills:</b> These are critical 'soft skills' important to every TWer across PS and Operations. They enable us to excel at what we do and provide our competitive advantage through areas like Consulting, Leadership, Impact, and Cultivation.</li>
                    <li><b>Craft Skills:</b> The specialized knowledge and applied abilities required to deliver value within a defined area of expertise (e.g., Product Strategy, Data Engineering, or User Experience).</li>
                    <li><b>Technical Skills:</b> The granular knowledge needed to deliver and support software, including specific programming languages, frameworks, testing tools, and infrastructure technologies.</li>
                    <li><b>Language Skills:</b> The spoken (or sign) languages you can use to collaborate with colleagues and clients globally.</li>
                  </ul>
              </li>
            </ul>`
      },
      {
        h: 'Should I explore Archetypes and Skills?',
        p: ` <b>Yes!</b> Together these elements give a rounded picture of the knowledge you have now and want to develop next and can give you plenty of ideas for what to focus on for your growth`
      },
      {
        p: ` <b>Remember</b>&nbsp; that all these are a guide and should be
                seen as an inspiration. Everyone comes with their own set of
                experiences, skills and different paths, which is totally
                OK. We do not expect people to fit neatly into Archetype shaped
                boxes. Start small, and find some areas to focus on, let it
                inspire you, not define you.`
      }
    ],
    headerInfo: {
      title: `<b>Archetypes and Skills</b> are the foundational elements of our Global Capability Model.`,
      description: 'To understand more please visit the Reference Guide'
    }
  },
  reflectItem: {
    competency: {
      removeArrowTooltip: 'Remove competency from reflection list',
      notification: {
        title: 'Are you sure you want to remove this competency?',
        content:
          'The competency will be removed from your Growth canvas. You can add it again later.',
        confirmation: 'Remove competency'
      }
    },
    skill: {
      removeArrowTooltip: 'Remove skill from reflection list',
      notification: {
        title: 'Are you sure you want to remove this skill?',
        content:
          'Your practice level and learning priority information will be lost.<br/>The skill will be also removed from your profile.',
        confirmation: 'Remove skill'
      }
    }
  }
};

export const specialCharactersPattern = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
